/**
 * https://www.soundjay.com/beep-sounds-1.html
 * 
 * Place sound .wavs in /assets/sounds/
 * Add code-friendly name to enumeration mapped to filename
 * 
 * audio.play(Sound.ErrorBeep)
 */
import { Injectable } from "@angular/core";

export enum Sound {
    ScanReceived = 'scan_received.mp3',
    ErrorBeep = 'ComputerError.mp3',
    GentleBeep = 'beep-07a.mp3',
    SadLoss = 'sad-loss.mp3',
    Tada = 'tada.mp3'
}

@Injectable({
    providedIn: 'root'
})
export class AudioService {
    audioClips: { [key: string]: HTMLAudioElement } = {};

    constructor() {
        for (const sound in Sound) {
            let audio = new Audio();
            let filename = (<any>Sound)[sound];
            audio.src = '/assets/sounds/' + filename;
            audio.load();
            this.audioClips[filename] = audio;
        }
    }

    play(
        sound: Sound
    ): void {
        this.audioClips[sound].play();
    }
}
